import { render } from "./ComparacionTotalesTable.vue?vue&type=template&id=03e79e2f&scoped=true"
import script from "./ComparacionTotalesTable.vue?vue&type=script&lang=js"
export * from "./ComparacionTotalesTable.vue?vue&type=script&lang=js"

import "./ComparacionTotalesTable.vue?vue&type=style&index=0&id=03e79e2f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03e79e2f"]])

export default __exports__